import {
  IconEdit,
  IconTrash,
  IconCopy,
  IconFileReport,
  IconFileTime,
  IconReportMoney,
  IconFileDescription,
  IconPaperclip,
  IconFileDownload,
  IconFileInvoice,
  IconX,
  IconCircleCheck,
  IconSquareRoundedCheck,
  IconSquareRoundedX,
  IconSquareRoundedPlus,
  IconTextPlus,
  IconPlus,
  IconUsers,
  IconBrandGoogleAnalytics,
  IconArticle,
  IconWorld,
  IconPencil,
  IconMinus,
  IconInfoSquare,
  IconBell,
} from "@tabler/icons";

// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

// BUTTON CONST
export const REJECT_REASON_PROCESS_BUTTON = "PROCESS";
export const CANCEL_BUTTON = "CANCEL";
export const CLOSE_BUTTON = "CLOSE";
export const CLEAR_BUTTON = "CLEAR";
export const REJECT_BUTTON = "REJECT";
export const APPROVE_BUTTON = "APPROVE";
export const SUBMIT_BUTTON = "SUBMIT";
export const UPDATE_BUTTON = "UPDATE";
export const NEXT_BUTTON = "NEXT";
export const PREV_BUTTON = "PREV";
export const DELETE_BUTTON = "DELETE";
export const RESET_BUTTON = "RESET";
export const SIGN_IN_BUTTON = "Sign in";
export const ADD_BUTTON = "ADD";
export const CREATE_BUTTON = "CREATE";
export const EDIT_BUTTON = "EDIT";
export const APPLY_BUTTON = "APPLY";
export const CONFiRM_BUTTON = "CONFIRM";

// icons
export const EDIT_ICON = IconEdit;
export const ADD_ICON = IconTextPlus;
export const PLUS_ICON = IconPlus;
export const COPY_ICON = IconCopy;
export const CLOSE_CROSS_ICON = IconX;
export const TRASH_ICON = IconTrash;
export const DELETE_ICON = IconTrash;
export const BELL_ICON = IconBell;
export const SUBMIT_REPORT_ICON = IconFileReport;
export const INVOICE_LINE_TIME_REPORTS_ICON = IconFileTime;
export const INVOICE_LINE_EXPENSE_REPORTS_ICON = IconReportMoney;
export const INVOICE_LINE_STANDARD_LINE_ITEM_ICON = IconFileDescription;
export const INVOICE_LINE_ADD_ATTACHMENT_ICON = IconPaperclip;
export const INVOICE_LINE_VIEW_ATTACHMENT_ICON = IconFileInvoice;
export const INVOICE_LINE_DOWNLOAD_ATTACHMENT_ICON = IconFileDownload;
export const ICON_X = IconX;
export const ICON_CIRCLE_CHECK = IconCircleCheck;
export const ICON_SQUARE_CHECK = IconSquareRoundedCheck;
export const ICON_SQAURE_X = IconSquareRoundedX;
export const ICON_PLUS = IconPlus;
export const ICON_USERS = IconUsers;
export const ICON_MATCH_ANALYSIS = IconBrandGoogleAnalytics;
export const ICON_DOCUMENT = IconArticle;
export const ICON_WORLD = IconWorld;
export const ICON_MINUS = IconMinus;
export const ICON_INFO = IconInfoSquare;

// Icon Size
export const SIZE_FILE_PREVIEW_ICON = "small";

export const MAX_RECORDS_LENGTH = 180;
export const MAX_RECORDS = 200;
export const DEFAULT_PAGE_SIZE = 20;

// constants for notifications
export const NOTIFICATION_TYPE_ERROR = "error";
export const NOTIFICATION_TYPE_WARNING = "warning";
export const NOTIFICATION_TYPE_INFO = "info";
export const NOTIFICATION_TYPE_SUCCESS = "success";

export const ERROR = "error";
export const WARNING = "warning";
export const INFO = "info";
export const SUCCESS = "success";







// constants for applicant
export const INITIAL_QUALIFICATION = "Initial Qualification";
export const SHORTLISTED = "Shortlisted";
export const FIRST_INTERVIEW = "First Interview";
export const SECOND_INTERVIEW = "Second Interview";
export const CONTRACT_PROPOSAL = "Contract Proposal";
export const CONTRACT_SIGNED = "Contract Signed";
export const REJECTED = "Rejected";

export const STAGE_OPTIONS = [
  INITIAL_QUALIFICATION,
  SHORTLISTED,
  FIRST_INTERVIEW,
  SECOND_INTERVIEW,
  CONTRACT_PROPOSAL,
  CONTRACT_SIGNED,
  REJECTED,
];

export const IN_PROGRESS = "In Progress";
export const READY_FOR_NEXT_STAGE = "Ready for Next Stage";
export const BLOCKED = "Blocked";

export const STATE_OPTIONS = [IN_PROGRESS, READY_FOR_NEXT_STAGE, BLOCKED];

export const BEGINNER_SKILL_NAME = "Beginner";
export const BEGINNER_SKILL_VALUE = 2;

export const ADVANCED_SKILL_NAME = "Advanced";
export const ADVANCED_SKILL_VALUE = 5;

export const PROFICIENT_SKILL_NAME = "Proficient";
export const PROFICIENT_SKILL_VALUE = 8;

export const EXPERT_SKILL_NAME = "Expert";
export const EXPERT_SKILL_VALUE = 10;

export const EMPLOYMENT_DESCRIPTION_CHARACTER_LIMIT = 400;
export const APPLICATION_ANALYTIC_STATUS = "DRAFT";
export const DRAFT_STAGE_CHANGE_ERROR_MAX_DISPLAYED_APPLICATION = 5;
export const MAX_APPLICATIONS_CHAR_LENGTH_TO_SHOW = 50;
export const MOVE_STAGE_LEFT = "left";
export const MOVE_STAGE_RIGHT = "right";
export const MAX_SELECTION_SKILL_COMPARISON = 5;

export const maTableCellBorderRadius = "8px";

export const KANBAN_STATE_OPTIONS = [
  { id: 1, name: "In Progress", value: "normal" },
  { id: 2, name: "Ready For Next Stage", value: "done" },
  { id: 3, name: "Blocked", value: "blocked" },
];

export const SKILL_LEVELS = [
  {
    id: 1,
    skillName: BEGINNER_SKILL_NAME,
    skillValue: BEGINNER_SKILL_VALUE,
  },
  {
    id: 2,
    skillName: ADVANCED_SKILL_NAME,
    skillValue: ADVANCED_SKILL_VALUE,
  },
  {
    id: 3,
    skillName: PROFICIENT_SKILL_NAME,
    skillValue: PROFICIENT_SKILL_VALUE,
  },
  {
    id: 4,
    skillName: EXPERT_SKILL_NAME,
    skillValue: EXPERT_SKILL_VALUE,
  },
];

export const APPLICATION_FINAL_STAGES = [REJECTED, CONTRACT_SIGNED];

export const START_DATE = "Start Date";
export const END_DATE = "End Date";
export const DATE_CLEAR_TITLE = "Clear Date";
export const DATE_FORMAT = "dd-MM-yyyy";
export const DATE_FORMAT_POST = "yyyy-MM-dd";
export const ADD_EDIT_FORM_TRANSITION_DIRECTION = "down";

export const DROP_ZONE_TEXT = "Drag and drop a file here or click — only PDF or DOCX documents are allowed";
export const LOG_COUNT_THRESHOLD = 3;
export const NOT_AVAILABLE = "N/A";
export const AD_ID = 2

export const MAMOCKDATA = {
  status: "COMPLETE",
  status_code: "RAS-1000",
  message: "Fetched comparison data",
  match_analytic_id: "8169d0e2-2713-4407-a0ea-249b7d9bc20a",
  job_position_id: "93da2517-f4b2-4624-affe-8899833e1230",
  data: {
    required_skill: [
      {
        id: 210,
        skill_name: "cybersecurity",
        priority: "high",
        mandatory_skill: true,
      },
      {
        id: 231,
        skill_name: "Machine Learning",
        priority: "high",
        mandatory_skill: true,
      },
      {
        id: 253,
        skill_name: "JavaScript",
        priority: "high",
        mandatory_skill: true,
      },
      {
        id: 266,
        skill_name: "React",
        priority: "medium",
        mandatory_skill: true,
      },
      {
        id: 242,
        skill_name: "Data Visualization",
        priority: "medium",
        mandatory_skill: true,
      },
      {
        id: 214,
        skill_name: "TensorFlow",
        priority: "medium",
        mandatory_skill: true,
      },
      {
        id: 221,
        skill_name: "Apache Spark",
        priority: "low",
        mandatory_skill: false,
      },
      {
        id: 278,
        skill_name: "Node.js",
        priority: "low",
        mandatory_skill: false,
      },
    ],
    applicants: [
      {
        application_id: "ca0d1dcb-2a36-421e-adb1-58ce6ccf703c",
        application_name: "Serena Williams",
        status: "Status1",
        match_rank: "Match Rank1",
        skill_rank: "Skill Rank1",
        skills: {
          match_count: "5/8",
          skill_attributes: [
            {
              skill_name: "cybersecurity",
              is_match: true,
              compatibilityScore: 100,
            },
            {
              skill_name: "TensorFlow",
              is_match: false,
            },
            {
              skill_name: "Apache Spark",
              is_match: true,
              compatibilityScore: 50,
            },
            {
              skill_name: "JavaScript",
              is_match: true,
              compatibilityScore: 75,
            },
            {
              skill_name: "React",
              is_match: true,
              compatibilityScore: null,
            },
            {
              skill_name: "Node.js",
              is_match: true,
              compatibilityScore: 25,
            },
          ],
        },
        qualification_matched: "Matched",
        allSkills: [
          {
            jPSkillName: "cybersecurity",
            priority: "high",
            matchedApplicantSkillName: "cybersecurity",
            match: true,
            applicantProefficiencey: 100,
          },
          {
            jPSkillName: "Machine Learning",
            priority: "high",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "JavaScript",
            priority: "high",
            matchedApplicantSkillName: "JavaScript",
            match: true,
            applicantProefficiencey: 75,
          },
          {
            jPSkillName: "React",
            priority: "medium",
            matchedApplicantSkillName: "React",
            match: true,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Data Visualization",
            priority: "medium",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "TensorFlow",
            priority: "medium",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Apache Spark",
            priority: "low",
            matchedApplicantSkillName: "Apache Spark",
            match: true,
            applicantProefficiencey: 50,
          },
          {
            jPSkillName: "Node.js",
            priority: "low",
            matchedApplicantSkillName: null,
            match: true,
            applicantProefficiencey: 25,
          },
        ],
      },
      {
        application_id: "459efdd6-149a-451b-b4c4-64e250112824",
        application_name: "Alex Hales",
        status: "Status2",
        match_rank: "Match Rank2",
        skill_rank: "Skill Rank2",
        skills: {
          match_count: "4/8",
          skill_attributes: [
            {
              skill_name: "cybersecurity",
              is_match: false,
            },
            {
              skill_name: "TensorFlow",
              is_match: true,
              compatibilityScore: 25,
            },
            {
              skill_name: "Apache Spark",
              is_match: true,
              compatibilityScore: 100,
            },
            {
              skill_name: "JavaScript",
              is_match: false,
              compatibilityScore: 50,
            },
            {
              skill_name: "React",
              is_match: true,
            },
            {
              skill_name: "Node.js",
              is_match: true,
              compatibilityScore: 75,
            },
          ],
        },
        qualification_matched: "Matched",
        allSkills: [
          {
            jPSkillName: "cybersecurity",
            priority: "high",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Machine Learning",
            priority: "high",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "JavaScript",
            priority: "high",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "React",
            priority: "medium",
            matchedApplicantSkillName: "React",
            match: true,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Data Visualization",
            priority: "medium",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "TensorFlow",
            priority: "medium",
            matchedApplicantSkillName: "TensorFlow",
            match: true,
            applicantProefficiencey: 25,
          },
          {
            jPSkillName: "Apache Spark",
            priority: "low",
            matchedApplicantSkillName: "Apache Spark",
            match: true,
            applicantProefficiencey: 100,
          },
          {
            jPSkillName: "Node.js",
            priority: "low",
            matchedApplicantSkillName: "Node.js",
            match: true,
            applicantProefficiencey: 75,
          },
        ],
      },
      {
        application_id: "3a41d64d-8726-4e09-bb23-ae33fc91ff10",
        application_name: "John Doe",
        status: "Status3",
        match_rank: "Match Rank3",
        skill_rank: "Skill Rank3",
        skills: {
          match_count: "3/8",
          skill_attributes: [
            {
              skill_name: "cybersecurity",
              is_match: true,
              compatibilityScore: 75,
            },
            {
              skill_name: "TensorFlow",
              is_match: false,
              compatibilityScore: 25,
            },
            {
              skill_name: "Apache Spark",
              is_match: false,
              compatibilityScore: 50,
            },
            {
              skill_name: "JavaScript",
              is_match: true,
            },
            {
              skill_name: "React",
              is_match: true,
            },
            {
              skill_name: "Node.js",
              is_match: false,
            },
          ],
        },
        qualification_matched: "Not Matched",
        allSkills: [
          {
            jPSkillName: "cybersecurity",
            priority: "high",
            matchedApplicantSkillName: "cybersecurity",
            match: true,
            applicantProefficiencey: 75,
          },
          {
            jPSkillName: "Machine Learning",
            priority: "high",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "JavaScript",
            priority: "high",
            matchedApplicantSkillName: "JavaScript",
            match: true,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "React",
            priority: "medium",
            matchedApplicantSkillName: "React",
            match: true,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Data Visualization",
            priority: "medium",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "TensorFlow",
            priority: "medium",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Apache Spark",
            priority: "low",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Node.js",
            priority: "low",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
        ],
      },
      {
        application_id: "3a41d64d-8726-4e09-bb23-ae33fc91ff11",
        application_name: "Will Smith",
        status: "Status4",
        match_rank: "Match Rank4",
        skill_rank: "Skill Rank4",
        skills: {
          match_count: "4/8",
          skill_attributes: [
            {
              skill_name: "cybersecurity",
              is_match: true,
              compatibilityScore: 100,
            },
            {
              skill_name: "TensorFlow",
              is_match: false,
              compatibilityScore: 50,
            },
            {
              skill_name: "Apache Spark",
              is_match: false,
              compatibilityScore: 75,
            },
            {
              skill_name: "JavaScript",
              is_match: false,
            },
            {
              skill_name: "React",
              is_match: true,
            },
            {
              skill_name: "Node.js",
              is_match: true,
              compatibilityScore: 25,
            },
          ],
        },
        qualification_matched: "Not Matched",
        allSkills: [
          {
            jPSkillName: "cybersecurity",
            priority: "high",
            matchedApplicantSkillName: "cybersecurity",
            match: true,
            applicantProefficiencey: 100,
          },
          {
            jPSkillName: "Machine Learning",
            priority: "high",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "JavaScript",
            priority: "high",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "React",
            priority: "medium",
            matchedApplicantSkillName: "React",
            match: true,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Data Visualization",
            priority: "medium",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "TensorFlow",
            priority: "medium",
            matchedApplicantSkillName: "TensorFlow",
            match: true,
            applicantProefficiencey: 50,
          },
          {
            jPSkillName: "Apache Spark",
            priority: "low",
            matchedApplicantSkillName: null,
            match: false,
            applicantProefficiencey: null,
          },
          {
            jPSkillName: "Node.js",
            priority: "low",
            matchedApplicantSkillName: "Node.js",
            match: true,
            applicantProefficiencey: 25,
          },
        ],
      },
    ],
  },
};

export const applicationthresholdmockdata = {
  status: "success",
  data: [
    {
      company_id: false,
      level: "default",
      attribute_type: "application_metrics_threshold",
      attribute_data: {
        attribute_data: [
          {
            id: 1,
            uom: "months",
            type: "days",
            label: "Education Gap",
            active: true,
            upward: true,
            threshold: 6,
          },
          {
            id: 2,
            uom: "months",
            type: "days",
            label: "Employment Gap",
            active: true,
            upward: true,
            threshold: 6,
          },
          {
            id: 3,
            uom: "months",
            type: "number",
            label: "Employment Tenure",
            active: false,
            upward: true,
            threshold: 12,
          },
          {
            id: 4,
            uom: "percentage",
            type: "number",
            label: "High priority skills",
            active: false,
            upward: false,
            threshold: 75,
          },
          {
            id: 5,
            uom: "percentage",
            type: "number",
            label: "Medium priority  skill",
            active: false,
            upward: false,
            threshold: 75,
          },
        ],
      },
    },
  ],
};
